import { render, staticRenderFns } from "./thesaurus_management.vue?vue&type=template&id=47a18115&scoped=true&"
import script from "./thesaurus_management.vue?vue&type=script&lang=js&"
export * from "./thesaurus_management.vue?vue&type=script&lang=js&"
import style0 from "./thesaurus_management.vue?vue&type=style&index=0&id=47a18115&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a18115",
  null
  
)

export default component.exports